(function (global) {
  'use strict';
  const instances = new WeakMap();
  const money = value => new Intl.NumberFormat('es-MX', {
    style: 'currency', currency: 'MXN', minimumFractionDigits: Number(value) % 1 ? 2 : 0, maximumFractionDigits: 2
  }).format(value);

  function mount(options) {
    const root = options.root || document;
    if (instances.has(root)) return instances.get(root);
    const catalog = options.catalog;
    const adapter = options.cart;
    if (!catalog || !adapter || typeof adapter.add !== 'function') {
      throw new Error('Se requieren catálogo y adaptador de carrito.');
    }
    const selector = '.galEstreno[data-card-variant]';
    const notify = (name, detail) => root.dispatchEvent(new CustomEvent(name, { detail }));
    function product(card) { return catalog[card.dataset.sku]; }
    function available(card, size) {
      const option = product(card)?.sizes?.[size];
      return !!(option && option.variant && Number.isFinite(Number(option.price)) && option.available !== false);
    }
    function getSelection(card) {
      const selected = card.dataset.selectedSize;
      const marked = card.querySelector('.preTalla[aria-pressed="true"]')?.dataset.size;
      const size = [selected, marked, '100', '50'].find(value => value && available(card, value));
      if (!size) return null;
      const item = product(card), option = item.sizes[size];
      return { sku: card.dataset.sku, name: item.name, size, variantId: String(option.variant), price: Number(option.price), modelCode: card.dataset.variantCode };
    }
    function refreshCard(card) {
      const selection = getSelection(card);
      card.querySelectorAll('.preTalla[data-card-action="select-size"]').forEach(button => {
        const size = button.dataset.size;
        button.disabled = !available(card, size);
        button.setAttribute('aria-pressed', String(selection?.size === size));
        const price = product(card)?.sizes?.[size]?.price;
        if (price != null && button.querySelector('strong')) button.querySelector('strong').textContent = money(Number(price));
      });
      const add = card.querySelector('[data-card-action="add-to-cart"]');
      if (add) {
        add.disabled = !selection || add.dataset.busy === 'true';
        add.setAttribute('aria-label', selection ? `Agregar al ${options.cartLabel || 'carrito'}: ${selection.name} de ${selection.size} ml` : 'Presentación no disponible');
      }
      if (selection) {
        card.dataset.selectedSize = selection.size;
        card.dataset.selectedVariant = selection.variantId;
        card.dataset.selectedPrice = selection.price;
      }
      return selection;
    }
    function refresh(scope) {
      const current = scope || root;
      if (current.matches?.(selector)) refreshCard(current);
      current.querySelectorAll?.(selector).forEach(refreshCard);
    }
    async function onClick(event) {
      const action = event.target.closest?.('[data-card-action]');
      const card = action?.closest(selector);
      if (!card || !root.contains(card)) return;
      if (action.dataset.cardAction === 'open-product') return; // Enlace nativo: sólo navega.
      if (!['select-size', 'add-to-cart'].includes(action.dataset.cardAction)) return;
      event.preventDefault();
      event.stopPropagation();
      if (action.disabled) return;
      if (action.dataset.cardAction === 'select-size') {
        if (!available(card, action.dataset.size)) return;
        card.dataset.selectedSize = action.dataset.size;
        const selection = refreshCard(card);
        notify('velantis:product-card:selection', selection);
        options.onSelection?.(selection, card);
        return;
      }
      if (action.dataset.busy === 'true') return;
      const selection = refreshCard(card);
      if (!selection) return;
      const item = {
        name: selection.name, sku: selection.sku,
        ruta: card.querySelector('[data-card-action="open-product"]')?.href || '',
        precio: selection.price, qty: 1, talla: selection.size, v: selection.variantId
      };
      action.dataset.busy = 'true';
      action.disabled = true;
      action.setAttribute('aria-busy', 'true');
      try {
        await adapter.add(item);
        notify('velantis:product-card:added', { item: { ...item }, modelCode: selection.modelCode });
        options.onAdded?.(item, card);
      } catch (error) {
        notify('velantis:product-card:error', { sku: item.sku, message: String(error.message || error) });
        options.onError?.(error, card);
      } finally {
        delete action.dataset.busy;
        action.removeAttribute('aria-busy');
        refreshCard(card);
      }
    }
    root.addEventListener('click', onClick);
    const controller = {
      version: '1.0.0', refresh, getSelection,
      destroy() { root.removeEventListener('click', onClick); instances.delete(root); }
    };
    instances.set(root, controller);
    refresh();
    return controller;
  }
  function nativeCartAdapter(nativeCart) {
    if (!nativeCart || typeof nativeCart.add !== 'function') throw new Error('VelantisCart.add no está disponible.');
    return { add: item => nativeCart.add(item) };
  }
  global.VelantisProductCards = Object.freeze({ version: '1.0.0', mount, nativeCartAdapter });
})(window);
